import React, { memo, useState } from "react";
import {
  Stack,
  Typography,
  FormControlLabel,
  Switch,
  Grid,
  Container,
} from "investira.react.components";
import CapitalSocialCard from "./CapitalSocialCard";
import PatrimonioCard from "./PatrimonioCard";
import TecnicoCard from "./TecnicoCard";
import HistoricoFinanceiro from "./HistoricoFinanceiro";
import { useEmpresasContext } from "../../../../../contexts/EmpresasContext";

const ContabilSection = memo((props) => {
  const { pessoa } = props;
  const { state, actions } = useEmpresasContext();

  const [showCount, setShowCount] = useState(0);

  function updateShow() {
    setShowCount((prevShow) => {
      return prevShow + 1;
    });
  }

  const handleChange = (event) => {
    actions.handleShowPreciseChange(event.target.checked);
  };

  // if (showCount >= 3) {
  //   return null;
  // }

  return (
    <Stack
      spacing={2}
      sx={{ py: 2 }}
      component="section"
      aria-label={`Históricos do Patrimônio líquido, Capital Social, Superávit/Déficit Técnico e Balanços da ${
        pessoa.pessoa_fantasia || pessoa.pessoa
      }`}
    >
      <Stack
        direction="row"
        spacing={3}
        alignItems="center"
        justifyContent="space-between"
        sx={{ py: 1 }}
      >
        <Stack>
          <Typography variant="h6" color="textPrimary" component="h3">
            Contábil
          </Typography>
        </Stack>
        <Stack>
          <FormControlLabel
            sx={{ marginRight: 0 }}
            control={
              <Switch checked={state.showPrecise} onChange={handleChange} />
            }
            label={
              <Typography variant="body2" color="textPrimary">
                Valores simples
              </Typography>
            }
          />
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: "column", md: "row" }}
        sx={{ gap: 2, flexWrap: "wrap" }}
      >
        <PatrimonioCard updateShow={updateShow} />
        {state.pessoa?.setor_id === "65.41.3.00" ? (
          <TecnicoCard updateShow={updateShow} />
        ) : (
          <CapitalSocialCard updateShow={updateShow} />
        )}
      </Stack>
      <HistoricoFinanceiro updateShow={updateShow} pessoa={pessoa} />
    </Stack>
  );
});

export default ContabilSection;
